var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', ("button_" + _vm.type), { 'button_disabled': _vm.disabled }],attrs:{"type":_vm.buttonNativeType},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }